import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'
import SuccessHandler from '../SuccessHandler'

/* private SupplierOrderPositions Types */
import {
  _SupplierOrderPosition
} from '../namespace-helper'

import _ from 'lodash'

const selectedSupplierOrderPositionTemplate = {
  id: 0,
  product: {
    id: 0,
    reference: null,
    product_description: {},
    manufacturer: {
      name: null
    }
  },
  delivery_time: {},
  discounts: [],
  unit_price: '0,00',
  suppliers_offers_position: {
    suppliers_offer: {
      currency: {
        name: null
      }
    }
  }

}
export default {
  namespaced: true,
  state: {
    selectedSupplierOrderPosition: _.cloneDeep(selectedSupplierOrderPositionTemplate),
    supplierOrderPositions: [],
    supplierOrderPositionLoading: false,
    supplierOrderPositionRemoving: false,
    openDialog: false
  },
  mutations: {
    [_SupplierOrderPosition.mutations.setSelectedSupplierOrderPosition] (state, payload) {
      if (payload !== null) {
        state.selectedSupplierOrderPosition = payload
      } else {
        state.selectedSupplierOrderPosition = _.cloneDeep(selectedSupplierOrderPositionTemplate)
      }
    },
    [_SupplierOrderPosition.mutations.setSupplierOrderPositions] (state, payload) {
      state.supplierOrderPositions = payload
    },
    [_SupplierOrderPosition.mutations.setRemovingSupplierOrderPosition] (state, payload) {
      state.supplierOrderPositionRemoving = payload
    },
    [_SupplierOrderPosition.mutations.setOpenCloseDialogState] (state) {
      state.openDialog = !state.openDialog
    }
  },
  actions: {
    [_SupplierOrderPosition.actions.saveSupplierOrderPosition] (context, payload) {
      const data = JSON.stringify(payload)

      return new Promise((resolve, reject) => {
        if (payload.id === 0) {
          var url = API_URL + '/api/v1/supplierOrderPositions'

          axios.post(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            ErrorHandler.clear(store)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            resolve(r)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        } else {
          url = API_URL + '/api/v1/supplierOrderPositions/' + payload.id

          axios.put(url, data, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + store.getters.getBearerToken
            }
          }
          ).then(function (r) {
            ErrorHandler.clear(store)
            SuccessHandler.handleApiSuccess(store, r.data.message)
            resolve(r)
          }, function (err) {
            ErrorHandler.handleApiError(store, err)
            reject(err)
          }).catch(e => console.error('#### ' + e))
        }
      })
    },
    [_SupplierOrderPosition.actions.loadSupplierOrderPositionsForSupplierOrder] (context, payload) {
      var url = API_URL + '/api/v1/supplierOrderPositions/supplierOrder/' + payload.id

      return new Promise((resolve, reject) => {
        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          ErrorHandler.clear(store)
          context.commit(_SupplierOrderPosition.mutations.setSupplierOrderPositions, r.data.data)
          resolve(r)
        }, function (err) {
          context.commit(_SupplierOrderPosition.mutations.setSupplierOrderPositions, null)
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_SupplierOrderPosition.actions.deleteSupplierOrderPosition] (context, payload) {
      context.commit(_SupplierOrderPosition.mutations.setRemovingSupplierOrderPosition, true)

      var url = API_URL + '/api/v1/supplierOrderPositions/' + payload.id

      return new Promise((resolve, reject) => {
        axios.delete(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          context.commit(_SupplierOrderPosition.mutations.setRemovingSupplierOrderPosition, false)
          ErrorHandler.clear(store)
          SuccessHandler.handleApiSuccess(store, r.data.message)
          resolve(r)
        }, function (err) {
          context.commit(_SupplierOrderPosition.mutations.setRemovingSupplierOrderPosition, false)
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_SupplierOrderPosition.actions.loadStatuses] (context, payload) {
      return new Promise((resolve, reject) => {
        var url = API_URL + '/api/v1/supplierOrderPositionStatuses'

        axios.get(url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          ErrorHandler.clear(store)
          resolve(r)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
          reject(err)
        }).catch(e => console.error('#### ' + e))
      })
    },
    [_SupplierOrderPosition.actions.setSelectedSupplierOrderPosition] (context, payload) {
      context.commit(_SupplierOrderPosition.mutations.setSelectedSupplierOrderPosition, payload)
    },
    [_SupplierOrderPosition.actions.openCloseDialog] ({ commit }) {
      commit(_SupplierOrderPosition.mutations.setOpenCloseDialogState)
    },
    [_SupplierOrderPosition.actions.resetState] (context, payload) {
      context.commit(_SupplierOrderPosition.mutations.setSupplierOrderPositions, [])
      context.commit(_SupplierOrderPosition.mutations.setSelectedSupplierOrderPosition, null)
    }

  },
  getters: {
    [_SupplierOrderPosition.getters.supplierOrderPositions] (state) {
      return state.supplierOrderPositions
    },
    [_SupplierOrderPosition.getters.getSelectedSupplierOrderPosition] (state) {
      return state.selectedSupplierOrderPosition
    },
    [_SupplierOrderPosition.getters.getOpenDialogState] (state) {
      return state.openDialog
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/SupplierOrderPosition/supplierOrderPositions.js